// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { TileSize, TileSizeMobile } from '../../_components/ui';
import { TeaserBoxVersion } from '../TeaserBox.contracts';
import { TeaserBoxAddonsMixin } from '../TeaserBox.shared';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let TeaserBoxInnerGrid1XL = class TeaserBoxInnerGrid1XL extends TeaserBoxAddonsMixin {
    constructor() {
        super(...arguments);
        this.gridConfig = {
            defaultSize: TileSize.S,
            mobileSize: TileSizeMobile.TILE,
            tiles: {
                0: TileSize.XL
            },
            listOffset: 1,
            listType: false
        };
    }
};
TeaserBoxInnerGrid1XL.moduleVersion = TeaserBoxVersion['1XL'];
TeaserBoxInnerGrid1XL = __decorate([
    Component({
        name: 'TeaserBoxInnerGrid1XL'
    })
], TeaserBoxInnerGrid1XL);
export { TeaserBoxInnerGrid1XL };
